import React from "react";
import KuikaAvatar from "../../../../ui-kit/kuika-avatar/kuika-avatar";
import { ShowcaseFrame } from "../_layout/showcase-frame";
import { SpecRow } from "../_layout/spec-row";
import { noop } from "../_layout/utils";
import { IShowcaseAxisValue, VariantGrid } from "../_layout/variant-grid";

const SIZES: IShowcaseAxisValue[] = [
  { value: "20", label: "20px" },
  { value: "24", label: "24px" },
  { value: "32", label: "32px" },
  { value: "36", label: "36px" },
  { value: "64", label: "64px" }
];

const SEED_NAMES: string[] = [
  "Furkan Ceylan",
  "Ayşe Yılmaz",
  "Mehmet Demir",
  "Zeynep Kaya",
  "Emre Şahin",
  "Elif Arslan"
];

const initialsOf = (name: string): string =>
  name
    .split(" ")
    .map((part: string): string => part.charAt(0))
    .join("")
    .toUpperCase();

export const AvatarStory: React.FC = (): JSX.Element => {
  return (
    <ShowcaseFrame
      title="Avatar"
      componentName="KuikaAvatar"
      sourcePath="ui-kit/kuika-avatar"
      description="The circle that stands for a person. Diameter is one number (--kuika-avatar-size); without a photo it takes one of ten identity colours keyed off a seed, so the same person is the same colour on every screen."
    >
      <VariantGrid
        label="size"
        caption="diameter drives width, height and the initials' glyph size together"
        cols={SIZES}
        render={(size: string): React.ReactNode => <KuikaAvatar size={Number(size)}>FC</KuikaAvatar>}
      />
      <SpecRow label="Content" caption="initials (neutral) · photo · initials with an identity colour">
        <KuikaAvatar size={48}>FC</KuikaAvatar>
        <KuikaAvatar size={48} src="/images/common/ai-avatar.svg" alt="Example photo" />
        <KuikaAvatar size={48} seed="furkan.ceylan@kuika.com">
          FC
        </KuikaAvatar>
      </SpecRow>
      <VariantGrid
        label="seed → identity colour"
        caption="one of ten grounds, picked from the seed — the same seed always lands on the same one"
        cols={SEED_NAMES}
        cellMinWidth={90}
        render={(name: string): React.ReactNode => (
          <KuikaAvatar size={40} seed={name}>
            {initialsOf(name)}
          </KuikaAvatar>
        )}
      />
      <SpecRow
        label="Interactive (role=button)"
        caption="only an avatar used as a trigger draws the keyboard focus ring — Tab to it to see the ring; a plain decorative avatar never shows one"
      >
        <KuikaAvatar size={40} role="button" tabIndex={0} onClick={noop} aria-label="Open account menu">
          FC
        </KuikaAvatar>
      </SpecRow>
    </ShowcaseFrame>
  );
};
